import AuthSkeleton from "../../common/authSkeleton/authSkeleton";

/* Owner invite: email, phone, 2 passwords, referral (5 stacked) plus the
   name row and the category row (2 two-up rows). */
const RegisterPageSkeleton = () => <AuthSkeleton fields={5} rows={2} />;

export default RegisterPageSkeleton;
